import { isValid, parse } from 'date-fns';
import { DATE_FORMAT_2 } from '../constants';

export const isValidDate = date => {
  return isValid(parse(date, DATE_FORMAT_2, new Date()));
};
